<freud-loader
	class="loading"
	*ngIf="loading"
	size="lg"
	[bgColor]="false"
></freud-loader>

<div class="back-button" routerLink="/clients">
	<span class="freud-icon freud-icon-arrow-left freud-icon-xs"></span>
	{{ 'CONTACT.GOBACK' | translate }}
</div>

<div class="about">
	<div
		*ngIf="contact && recurrencyData && recurrencyData.recurringCustomer"
		freud-tooltip
		[tooltipLabel]="getTooltipLabel()"
		tooltipPosition="right"
	>
		<div class="RECURRENCY-tag">
			<span>{{ 'CONTACT.RECURRENCY_CONTACT' | translate }}</span>
			<span class="freud-icon freud-icon-sync"></span>
		</div>
	</div>

	<div class="zk-flex zk-justify-between">
		<div class="headline">
			<p class="name">{{ contact && contact.displayName }}</p>
			<span
				(click)="editContact()"
				class="freud-icon freud-icon-edit freud-icon-md"
				pTooltip="{{ 'CONTACT.EDIT_PROFILE' | translate }}"
				tooltipPosition="top"
			></span>

			<span
				pTooltip="{{
					contact && contact.refUserId
						? ('CONTACT.CHAT' | translate)
						: ('CONTACT.ERRORS.NOACCOUNT' | translate)
				}}"
				tooltipPosition="top"
				class="freud-icon freud-icon-md freud-icon-message-circle"
				[ngClass]="{ disabled: contact && !contact.refUserId }"
				(click)="openChat()"
			></span>
		</div>
		<div>
			<freud-button (click)="openModal()" *ngIf="contact && contact.refUserId">
				<div class="zk-flex zk-gap-2">
					<span>{{ 'EXPORT.BUTTON' | translate }}</span>
					<span class="freud-icon freud-icon-file-export freud-icon-md"></span>
				</div>
			</freud-button>
		</div>
	</div>
	<contact-info [contactData]="contact"></contact-info>
</div>

<div class="tabs" *ngIf="contact">
	<tabs-row
		[tabList]="pages"
		[selectedTabIndex]="selectedTabIndex"
		(changeTab)="changeTab($event)"
	></tabs-row>

	<contact-follow-up
		(goToPromptuaries)="goTo({tab: 'appointments'})"
		[contact]="contact"
		[professionalId]="professionalId"
		*ngIf="selectedTabIndex === 0"
	></contact-follow-up>
	<div
		*ngIf="!loading && selectedTabIndex === 1"
		class="zk-flex zk-gap-10 zk-flex-col"
	>
		<journey-overview
			(goTo)="goTo($event)"
			[firstName]="contact ? contact.displayName.split(' ', 1)[0] : ''"
			[customerId]="contact.refUserId"
		></journey-overview>
		<contact-promptuaries-filter
			*ngIf="userData && userData.specialistIsCoe"
			(onSelectOption)="promptuariesFilter = $event"
		></contact-promptuaries-filter>
		<contact-promptuaries
			[filter]="promptuariesFilter"
			[clientId]="contact.refUserId"
			(newAppointment)="toggleScheduleModal()"
		></contact-promptuaries>
	</div>

	<contact-notes
		*ngIf="pages[1].state === 'visible' && selectedTabIndex === 2"
		[contact]="contact"
	></contact-notes>

	<contact-content
		*ngIf="selectedTabIndex === 3"
		[contactId]="contact.id"
		[contact]="contact"
	></contact-content>

	<contact-tests
		*ngIf="selectedTabIndex === 4"
		[contactId]="contact.refUserId"
	></contact-tests>
</div>

<export-modal
	[isOpen]="isExportModalOpen"
	(onClose)="isExportModalOpen = false"
	[customerId]="contact?.refUserId"
></export-modal>
